import { XStack, YStack } from "tamagui";

import { Select } from "@/components";
import type { ChoiceValue } from "@/conversation/AskUserQuestionsPanel/OptionParts";
import SkipOrSubmit from "@/conversation/AskUserQuestionsPanel/SkipOrSubmit";

export default function DropdownQuestion({
  options,
  value,
  onChange,
  onSubmit,
  onSkip,
  isLast,
  allowSkip = true,
  placeholder = "Select an option...",
}: {
  options: string[];
  value: ChoiceValue;
  onChange: (value: ChoiceValue) => void;
  onSubmit: () => void;
  onSkip: () => void;
  isLast: boolean;
  /** Show the Skip control. Off for required flows (e.g. rx). */
  allowSkip?: boolean;
  placeholder?: string;
}) {
  const selected = value.selected[0] ?? "";
  return (
    <YStack gap="$200" paddingHorizontal="$150" paddingBottom="$150">
      <Select
        value={selected}
        onValueChange={(val: string) =>
          onChange({ selected: [val], otherText: "" })
        }
        items={options.map((option) => ({ label: option, value: option }))}
        placeholder={placeholder}
      />
      <XStack justifyContent="flex-end">
        <SkipOrSubmit
          showSkip={allowSkip}
          showSubmit
          submitDisabled={!selected}
          isLast={isLast}
          onSkip={onSkip}
          onSubmit={onSubmit}
        />
      </XStack>
    </YStack>
  );
}
